import React from 'react';
import parse from 'react-html-parser';
import { shape } from 'prop-types';
import styles from './Text.module.scss';

const TextElement = ({ content }) => (
  <div className={styles.wrapper}>
    <div className={styles.textContent}>{parse(content.text)}</div>
  </div>
);

TextElement.propTypes = {
  content: shape(),
};

TextElement.defaultProps = {
  content: null,
};

export default TextElement;
